namespace RioERP.Masters {
    export interface SmsGatewaySettingsForm {
        ApiKey: Serenity.StringEditor;
        Sender: Serenity.StringEditor;
        EntityId: Serenity.StringEditor;
        TemplateId: Serenity.StringEditor;
    }

    export class SmsGatewaySettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.SmsGatewaySettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SmsGatewaySettingsForm.init)  {
                SmsGatewaySettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(SmsGatewaySettingsForm, [
                    'ApiKey', w0,
                    'Sender', w0,
                    'EntityId', w0,
                    'TemplateId', w0
                ]);
            }
        }
    }
}
